import { FC } from 'react';

import { useFindAllServers } from '../hooks/useServers';

export const ServersProvider: FC = () => {
  useFindAllServers();

  return null;
};
